module.exports = __webpack_public_path__ + "media/images/global/projects/professional-development-4b638adefd3286463eb45fa04ce03e58.png";